import { instance } from '@/services/klarbuss-api'
import { AxiosResponse } from 'axios'

export function checkOut(arrivalUuid: string): Promise<AxiosResponse<unknown>> {
  return instance.post(`/arrival/${arrivalUuid}/check-out`)
}
